(ns bec-cljs-common.components.button
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.components.icon :refer [angle-down]]
            [bec-cljs-common.utils.css :as css]))

(defn button [& [props]]
  (let [loading? (or (:is-loading? props) (:loading? props))
        model (or (:model props) @(rf/subscribe [:model]))
        app-category @(rf/subscribe [:app-category])]
    (into
      [:button.button
       (merge
         (when (map? props)
           (dissoc props :loading? :is-loading? :ignore-brand-style?))
         {:class (str (:class props)
                   (when loading? " is-loading ")
                   (when (and (not (:ignore-brand-style? props)) (or (= model "split") (= app-category "darts"))
                           (not (= app-category "bec-core")))
                     " is-rounded "))
          :aria-label "button"
          :disabled (or (:disabled props) loading?)})]
      (r/children (r/current-component)))))

(defn link [& [props]]
  (let [loading? (or (:is-loading? props) (:loading? props))
        model (or (:model props) @(rf/subscribe [:model]))
        app-category @(rf/subscribe [:app-category])]
    (into
      [:button.is-clickable.is-link
       (merge
         (when (map? props)
           (dissoc props :loading? :is-loading? :ignore-brand-style?))
         {:class (str (:class props)
                   (when loading? " is-loading ")
                   (when (and (not (:ignore-brand-style? props)) (or (= model "split") (= app-category "darts"))
                           (not (= app-category "bec-core")))
                     " is-rounded "))
          :aria-label "button"
          :style (merge {:padding "0.25em 0.75em"}
                   (:style props))
          :disabled (or (:disabled props) loading?)})]
      (r/children (r/current-component)))))

(defn default [& [props]]
  (let [loading? (or (:is-loading? props) (:loading? props))
        app-category @(rf/subscribe [:app-category])]
    (if (or (= (or (:model props) @(rf/subscribe [:model])) "split")
          (not (= app-category "darts")))
      (into
        [button
         (merge
           (when (map? props)
             (dissoc props :loading? :is-loading? :model))
           {:class (or (:class props) " is-primary is-medium"
                     (when (= (or (:model props) @(rf/subscribe [:model])) "split")
                       " is-rounded "))
            :style (merge
                     {:justify-content "space-around"
                      :margin "1.5vmin"
                      :color (or (get (:style props) "--c2")
                               "hsl(var(--scheme-main-hue), var(--scheme-main-saturation), var(--lightness-black-bis))")
                      :background (get (:style props) "--c1")
                      :width (or (get (:style props) "--w") (:width (:style props)) "14rem")
                      :height (or (get (:style props) "--h") (:height (:style props)))}
                     (:style props))})]
        (r/children (r/current-component)))
      [:button.default-button
       (when (map? props)
         (merge
           (dissoc props :loading? :is-loading? :model)
           {:key key
            :class (str (:class props)
                     (when loading? " is-loading "))
            :style (merge
                     {"--w" (:width (:style props))
                      "--h" (:height (:style props))
                      "--c2" (:color (:style props))
                      "--c1" (:background (:style props))}
                     (:style props))
            :aria-label "button"
            :disabled (or (:disabled props) loading?)}))
       (into [:div.default-button-inner]
         (r/children (r/current-component)))])))

(defn border [& [props]]
  (let [model @(rf/subscribe [:model])
        app-category @(rf/subscribe [:app-category])]
    (if (or (= model "split") (not (= app-category "darts")))
      (into
        [button
         (merge
           (when (map? props)
             (dissoc props :loading? :is-loading?))
           {:class (or (:class props) " is-primary is-medium is-outlined "
                     (when (= (or (:model props) @(rf/subscribe [:model])) "split")
                       " is-rounded "))
            :style (merge
                     {:min-width (or (get (:style props) "--w") "14rem")
                      :width (get (:style props) "--w")
                      :height (get (:style props) "--h")
                      :justify-content "space-around"
                      :margin "1.5vmin"
                      :border-width "0.125em"
                      :background (or (get (:style props) "--c1")
                                    "hsl(var(--scheme-main-hue), var(--scheme-main-saturation), var(--lightness-black-bis))")
                      :color (or (get (:style props) "--c2") "var(--primary-brand-color)")}
                     (:style props))})]
        (r/children (r/current-component)))
      [default
       (when (map? props)
         (merge (dissoc props :background :color :border-color)
           {:class (:class props)
            :model model
            :style (merge
                     (:style props)
                     {:background (:border-color (:style props))})}))
       (into
         [:div.default-button-inner.border
          {:style {:background (:background props)
                   :color (:color props)}}]
         (r/children (r/current-component)))])))

(defn cancel [& [props]]
  (let [model @(rf/subscribe [:model])
        app-category @(rf/subscribe [:app-category])]
    (if (or (= model "split") (not (= app-category "darts")))
      (into
        [button
         (merge
           (when (map? props)
             (dissoc props :loading? :is-loading? :icon))
           {:class (or (:class props) " is-primary is-medium"
                     (when (= (or (:model props) @(rf/subscribe [:model])) "split")
                       " is-rounded "))
            :style (merge
                     {:min-width (or (get (:style props) "--w") "14rem")
                      :width (get (:style props) "--w")
                      :height (get (:style props) "--h")
                      :justify-content "space-around"
                      :margin "1.5vmin"
                      :position "absolute"
                      :top "0"
                      :left "0"
                      :z-index "1"
                      :background (or (get (:style props) "--c1")
                                    "hsl(var(--scheme-main-hue), var(--scheme-main-saturation), var(--lightness-black-bis))")
                      :color (or (get (:style props) "--c2") "var(--primary-brand-color)")}
                     (:style props))})
         (if (:icon props)
           (:icon props)
           [:span.icon [:i.fas.fa-times.lg]])]
        (r/children (r/current-component)))
      (into
        [default
         (merge
           (when (map? props) (dissoc props :icon))
           {:aria-label (or (:aria-label props) "close")
            :model model
            :class (str (:class props) " button-cancel ")})
         (if (:icon props)
           (:icon props)
           [:i.fas.fa-times
            {:style {:font-size "1.6rem"}}])]
        (r/children (r/current-component))))))

(defn circular [& [props]]
  (into
    [:button.default-button.circular
     (when (map? props)
       (assoc (dissoc props :loading?) :style (dissoc (:style props) :margin)))]
    (r/children (r/current-component))))

(defn glowing-icon-button [& [props]]
  [:a
   (merge
     (when (map? props)
       (dissoc props :icon :on-click :href :id :icon-props :disabled :button-style))
     {:style (merge
               {:display "flex"
                :align-items "center"
                :padding "0"
                :color "var(--text-strong)"}
               (:style props))})
   (into
     [:button.simple-button.is-clickable.glows
      {:type "button"
       :class (:class props)
       :id (:id props)
       :href (:href props)
       :on-click (:on-click props)
       :aria-label (:aria-label props)
       :disabled (:disabled props)
       :style (merge
                {:display "flex"
                 :align-items "center"
                 :justify-content "center"}
                (:button-style props))}
      (when (:icon props)
        [:span.icon #_.badge.pulsate.badge-is-danger.badge-is-small
         (merge
           (:icon-props props)
           {:style (merge
                     (:style (:icon-props props))
                     {:box-shadow "none"})})
         [(if (keyword? (:icon props))
            (:icon props)
            :i)
          {:class (when (string? (:icon props)) (:icon props))}]])]
     (r/children (r/current-component)))])

(defn hamburger [& [props]]
  (let [active? (or (:active? props) (:active? props))]
    [:button.is-clickable.glows.hamburger
     (merge
       (when (map? props) props)
       {:type "button"
        :aria-controls "navigation"
        :aria-expanded (if active? "true" "false")
        :class (str (:class props) (when active? " is-active "))
        :style {:width "3.5em"
                :height "3em"
                :margin "0.25em"
                "--is-clickable-drop-shadow-spread-1" "1.25em"
                "--is-clickable-drop-shadow-color-1" "var(--blue)"
                "--is-clickable-drop-shadow-spread-2" "0.5em"
                "--is-clickable-drop-shadow-color-2" "var(--blue)"}})
     [:span.hamburger-box
      [:span.hamburger-inner]]]))

(defn delete-cross-arrow [& [props]]
  (let [active? (or (:active? props) (:active? props))]
    [:button.is-clickable.glows.delete-cross.delete-cross-arrow
     (merge
       (when (map? props) (dissoc props :active? :active?))
       {:type "button"
        :aria-controls "navigation"
        :aria-expanded (if active? "true" "false")
        :class (str (:class props) (when-not active? " is-active "))
        :style (merge
                 {:width "3.5em"
                  :height "3em"
                  :margin "0.25em"}
                 (:style props))})
     [:span.delete-cross-box
      [:span.delete-cross-inner]]]))

(defn dynamic-menu-label [& [props]]
  [:div
   (merge
     (when (map? props) (dissoc props :active?))
     {:style (merge
               {:display "flex"
                :align-items "center"
                :padding-left "1em"
                :padding-right "1em"}
               (:style props))})
   (into
     [:p.menu-label
      {:style {:text-indent (if (:active? props) "initial" "-50rem")
               :transition (css/style-transition "text-indent")
               :overflow "hidden"}}]
     (r/children (r/current-component)))
   [:div
    {:style {:display (when (:active? props) "none")
             :background "var(--text-light)"
             :height "1px"
             :width "100%"}}]])

(defn dynamic-ul [& [props]]
  (into
    [:ul.is-collapsible
     (merge
       (when (map? props) (dissoc props :active?))
       {:style {:margin-left (if (:active? props) "2em" "1.15em")
                :padding 0
                :overflow "hidden"}})]
    (r/children (r/current-component))))

(defn dynamic-icon-label [& [props]]
  [:a
   (merge
     (when (map? props)
       (if (:icon props)
         (dissoc props :icon :inner-icon-label? :disabled :on-click :href :active? :id)
         (dissoc props :icon :inner-icon-label?)))
     {:style (merge
               {:display "flex"
                :align-items "center"
                :padding "0"
                :color "var(--text-strong)"}
               (:style props))})
   [:button.simple-button.is-clickable.glows
    {:type "button"
     :id (:id props)
     :class (:class props)
     :href (:href props)
     :disabled (:disabled props)
     :on-click (:on-click props)
     :style {:display "flex"
             :align-items "center"
             :padding (if (and (:inner-icon-label? props) (not (:active? props)))
                        "0.5rem"
                        "0.5rem 0.5rem 0.5rem 1.35rem")
             :transition "transform var(--transition-duration) ease, padding var(--transition-duration) ease"}}
    (when (:icon props)
      [:span.icon #_.badge.pulsate.badge-is-danger.badge-is-small
       (merge
         (:icon-props props)
         {:style (merge
                   (:style (:icon-props props))
                   {:box-shadow "none"})})
       [(if (keyword? (:icon props))
          (:icon props)
          :i)
        {:class (when (string? (:icon props)) (:icon props))}]])
    (into
      [:p
       {:style {:text-indent (if (:active? props) "initial" "-50rem")
                :overflow "hidden"
                :width "100%"
                :display "flex"
                :justify-content "space-between"
                :align-items "center"
                :text-align "start"
                :padding-left "0.25rem"
                :transition "text-indent calc(var(--transition-duration, 250ms)*1.5) ease"}}]
      (r/children (r/current-component)))]])

(defonce variables (r/atom {}))

(rf/reg-sub :dropdown
  (fn [_ [_ id]]
    (if id
      (get-in @variables [:dropdown id] nil)
      (:dropdown @variables))))

(defn dropdown [& [props]]
  (let [dropdown-key (or (:dropdown-key props) (:id props) :default-dropdown-key)]
    [:div.dropdown.is-active
     (dissoc props :button-label :button-props :dropdown-key)
     [:div.dropdown-trigger
      [button
       (merge
         {:aria-haspopup true
          :aria-controls (str dropdown-key "-menu")
          :on-click (fn [event]
                      (swap! variables assoc-in [:dropdown dropdown-key]
                        (not (get-in @variables [:dropdown dropdown-key] nil)))
                      (when (fn? (:on-click (:button-props props)))
                        ((:on-click (:button-props props)) event)))}
         (dissoc (:button-props props) :on-click))
       (when (:button-label props)
         [:span (:button-label props)])
       [angle-down
        {:aria-hidden (get-in @variables [:dropdown dropdown-key] nil)
         :active? (get-in @variables [:dropdown dropdown-key] nil)}]]]
     [:div.dropdown-menu.is-right
      {:id (str dropdown-key "-menu")
       :role "menu"}
      (into
        [:div.dropdown-content.is-collapsible
         {:class (when-not (get-in @variables [:dropdown dropdown-key] nil) "is-collapsed")
          :style {:max-height "60vh"}}]
        (r/children (r/current-component)))]]))